var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
class TimeCounter {
  constructor() {
    __publicField(this, "startTime");
    __publicField(this, "acumulatedTime", 0);
  }
  /**
   * Returns the elapsed time in milliseconds
   */
  getElapsedMilliseconds() {
    const ellapsedFromLastStart = this.startTime ? Date.now() - this.startTime : 0;
    return this.acumulatedTime + ellapsedFromLastStart;
  }
  /**
   * Returns the elapsed time in seconds.
   */
  getElapsedSeconds() {
    return Math.floor(this.getElapsedMilliseconds() / 1e3);
  }
  /**
   * Starts the time counter.
   */
  start() {
    if (!this.startTime) {
      this.startTime = Date.now();
    }
  }
  /**
   * Stops the time counter.
   */
  stop() {
    this.acumulatedTime = this.getElapsedMilliseconds();
    this.startTime = void 0;
  }
  /**
   * Resets the time counter.
   */
  reset() {
    this.acumulatedTime = 0;
    this.startTime = void 0;
  }
}

export { TimeCounter };
//# sourceMappingURL=TimeCounter.js.map
